import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '100%',
  },
  questionInput: {
    marginTop: 18,
    [theme.breakpoints.down('xs')]: {
      marginTop: 14,
      // zoom: 0.8,
    },
  },
  optionsListWithSearch: {
    [theme.breakpoints.up('sm')]: {
      height: ({ isInsideSidebar, provider }) => (isInsideSidebar ? null : provider ? '100%' : 530),
    },
    [theme.breakpoints.down('xs')]: {
      height: ({ isInsideSidebar, provider, embedded }) => (
        embedded ? '80vh' : (isInsideSidebar ? null : provider ? '100%' : '70vh')
      ),
    },
  },
}));
